import { SVGCanvas } from "../../../views/graph"

/**
 * Clears any existing canvases then appends a new one. Existing canvases are
 * first cleared so we can re-run _just_ canvas drawing if needed.
 *
 * @param data {object} { roots: [JSON], nodes: [JSON], edges: [JSON], scope: HTMLElement, layout: Layout }
 * @return {object} { roots: [JSON], nodes: [JSON], edges: [JSON], scope: HTMLElement, layout: Layout }
 */
export const renderSVGCanvas = data => {
  data.scope.querySelectorAll("workflow-svg").forEach(svg => svg.remove())
  data.scope.appendChild(new SVGCanvas(data.edges, data.layout))

  return data
}

